export enum FontSizeToken {
  fontSizeXxxs = '1.2rem',
  fontSizeXxs = '1.4rem',
  fontSizeXs = '1.6rem',
  fontSizeSm = '2.0rem',
  fontSizeMd = '2.4rem',
  fontSizeLg = '3.2rem',
  fontSizeXl = '4.0rem',
  fontSizeXxl = '4.8rem',
  fontSizeXxxl = '6.4rem',
  fontSizeDisplay = '8.0rem',
  fontSizeGiant = '9.6rem',
}

export default FontSizeToken

export type TFontSize =
  | 'fontSizeXxxs'
  | 'fontSizeXxs'
  | 'fontSizeXs'
  | 'fontSizeSm'
  | 'fontSizeMd'
  | 'fontSizeLg'
  | 'fontSizeXl'
  | 'fontSizeXxl'
  | 'fontSizeXxxl'
  | 'fontSizeDisplay'
  | 'fontSizeGiant'
